/* eslint-disable max-len */
const pageDashboardSushi = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/components/pages/dashboard/page-dashboard-sushi/page-dashboard-sushi.vue'
  );
const pageSushiInviteFriends = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/components/pages/dashboard/page-dashboard-sushi/pages/sushi-invite-friends/sushi-invite-friends.vue'
  );
const pageSushiLeaderboardInfo = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/components/pages/dashboard/page-dashboard-sushi/pages/sushi-leaderboard-info/sushi-leaderboard-info.vue'
  );
const pageSushiMyMarkets = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/components/pages/dashboard/page-dashboard-sushi/pages/sushi-my-markets/sushi-my-markets.vue'
  );
const pageSushiNotifications = () =>
  import(
    /* webpackChunkName: "dashboard" */ '@/components/pages/dashboard/page-dashboard-sushi/pages/sushi-notifications/sushi-notifications.vue'
  );

export default [
  {
    path: '/dashboard',
    component: pageDashboardSushi,
    props: true,
    meta: {
      requiresAuth: true,
      appContentFullWidth: true,
    },
    children: [
      {
        path: '',
        name: 'portfolio',
        component: pageSushiMyMarkets,
        meta: {
          appContentFullWidth: true,
        },
      },
      {
        path: 'leaderboard-info',
        name: 'dashboard-leaderboard-info',
        component: pageSushiLeaderboardInfo,
        meta: {
          appContentFullWidth: true,
        },
      },
      {
        path: 'invite-friends',
        name: 'dashboard-invite-friends',
        component: pageSushiInviteFriends,
        meta: {
          appContentFullWidth: true,
        },
      },
      {
        path: 'notifications',
        name: 'dashboard-notifications',
        component: pageSushiNotifications,
        meta: {
          appContentFullWidth: true,
        },
      },
    ],
  },
];
